// removed by extract-text-webpack-plugin
module.exports = {"profile-main":"_1xJiWtrg","profileMain":"_1xJiWtrg","avatar":"_3Hpsa_zp","copy":"_1PtbxFbx","name":"_3XnDBmJe","title":"_1oYh1sev","email":"QJLSdWXX","iama":"_2E18AYBI"};


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeView/ProfileMain/ProfileMain.pcss
// module id = 738
// module chunks = 0